import api from "PFCore/api";

export const uploadAttachment = (file: File) => {
  const formData = new FormData();

  // Saving activity attachment as "Chat::Attachment" "message" is required by API
  formData.append("type", "Chat::Attachment");
  formData.append("target_type", "message");
  formData.append("attachment", file);

  return api({
    method: "POST",
    url: "attachments",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: formData
  });
};
